import {
    UNASSIGN_DRIVERS_REQUEST,
    UNASSIGN_DRIVERS_RESULT,
    UNASSIGN_DRIVERS_OPEN_MODAL,
    UNASSIGN_DRIVERS_CLOSE_MODAL,
    UNASSIGN_DRIVERS_GET_KEYFOB_REQUEST,
    UNASSIGN_DRIVERS_GET_KEYFOB_RESULT,
    UNASSIGN_DRIVERS_SET_DEVICE,
} from 'Redux/actionTypes';

export const unassignDriversRequest = (data) => ({
    type: UNASSIGN_DRIVERS_REQUEST,
    payload: data
})

export const unassignDriversResult = (result) => ({
    type: UNASSIGN_DRIVERS_RESULT,
    payload: result
})

export const unassignDriversOpenModal = (items) => ({
    type: UNASSIGN_DRIVERS_OPEN_MODAL,
    payload: items
})

export const unassignDriversCloseModal = () => ({
    type: UNASSIGN_DRIVERS_CLOSE_MODAL
})

export const unassignDriversGetKeyFobRequest = (item) => ({
    type: UNASSIGN_DRIVERS_GET_KEYFOB_REQUEST,
    payload: item 
})

export const unassignDriversGetKeyFobResult = (result) => ({
    type: UNASSIGN_DRIVERS_GET_KEYFOB_RESULT,
    payload: result
})

export const unassignDriversSetDevice = (device) => ({
    type: UNASSIGN_DRIVERS_SET_DEVICE,
    payload: device
})